import { DashboardScreen } from './overview/DashboardScreen';
import { OperationsUpdate } from './overview/OperationsUpdate';
import { Presentation } from './overview/Presentation';
import { WellProgress } from './overview/WellProgress';
import { WellDiagram } from './overview/WellDiagram';
import { WellPrognosis } from './overview/WellPrognosis';
import { RtTimeLog } from './rtlogs/RtTimeLog';
import { RtTimeDepth } from './rtlogs/RtTimeDepth';
import { CompositeLog, PressureLog, RtDepthLog, RtPorePressure } from './rtlogs/DepthLogs';
import { Documents } from './Documents';
import type { ScreenKey } from '../lib/rails';
import type { Dashboard as DashboardData } from '../lib/types';

/** Draws the screen a tab points at; see SCREENS in lib/rails for the list. */
export function Screen({
  screen,
  data,
  wellId,
  wellName,
}: {
  screen: ScreenKey;
  data: DashboardData | null;
  wellId: number;
  wellName: string;
}) {
  switch (screen) {
    case 'dashboard':
      return data ? <DashboardScreen data={data} /> : null;
    case 'operations-update':
      return <OperationsUpdate />;
    case 'presentation':
      return <Presentation />;
    case 'well-progress':
      return <WellProgress />;
    case 'well-diagram':
      return <WellDiagram />;
    case 'well-prognosis':
      return <WellPrognosis />;
    case 'rt-time-log':
      return <RtTimeLog />;
    case 'rt-time-depth':
      return <RtTimeDepth />;
    case 'rt-depth-log':
      return <RtDepthLog />;
    case 'composite-log':
      return <CompositeLog />;
    case 'pressure-log':
      return <PressureLog />;
    case 'rt-pore-pressure':
      return <RtPorePressure />;
    case 'documents':
      return <Documents wellId={wellId} wellName={wellName} />;
  }
}
